module.exports = __webpack_public_path__ + "img/pay_04.80a40e55.png";